import type { FaireProductEntity } from "../../entity_types/product";

export const p_wps5dqa6cp: FaireProductEntity = {
  token: "p_wps5dqa6cp",
  type: "product",
  name: "Labradorite Mini Palm Stones - 1 pc",
  brandToken: "b_ciwhgi8nfq",
  brandName: "The Crystal Tabby",
  imageUrl:
    "https://cdn.faire.com/fastly/9316d16dac2097b73662458219c8cbbede1aba414b5d85ae8f62fd3adb3201f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/029f8f22bfbae0766b6cac954401fd9a7833024258cad88bb968476307f01602.jpeg",
    "https://cdn.faire.com/fastly/5f77375689aa5fb5d133a18b1b7fb395fd133a9f333c4701e1b1f7e1f19277e2.jpeg",
    "https://cdn.faire.com/fastly/a6ccf5d01efe22993a7475e8d4b56b3c42955ffd7c24a734f7e53b0f9a7d583b.jpeg",
  ],
  priceDollars: 5,
  description:
    '\nThis is for 1 labradorite mi i palm stone. \n\n Labradorite was found in Labrador, a Canadian province on the Isle of Paul. Labradorite are a plagioclase mineral which belongs to the feldspar family. It is most commonly known for the brilliant flashes of color ( blues, purples, pink, orange, green and yellows) called labradoressence caused by lamellar twinning inside the crystal. \n\nInuits once called labradorite a "fire stone" and would use powdered versions to help cure ailments/sickness. Inuit legend states that a warrior saw the Northern Lights trapped in the rocks and then struck it with his spear to free some of the lights. It can now be found in Mexico, Russia and Finland. \n\nSize: ~ 1.75-2.75 inches\n\nLocation: Canada\n\nSHIPPING CALCULATED AFTER CHECKOUT**\n\n*Picture may vary from piece to piece. \n',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:41.465Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
